var shadow={xs:{value:"0px 2px 4px rgba(0.4588235318660736, 0.4588235318660736, 0.4431372582912445, 0.14000000059604645)"},sm:{value:"0px 4px 8px rgba(0, 0, 0, 0.25)"},md:{value:"0px 4px 16px rgba(0, 0, 0, 0.25)"},lg:{value:"0px 4px 24px rgba(0, 0, 0, 0.25)"}};var tokens = {shadow:shadow};

var shadows = {
    xs: tokens.shadow.xs.value,
    sm: tokens.shadow.sm.value,
    md: tokens.shadow.md.value,
    lg: tokens.shadow.lg.value,
};

export { shadows as s };
//# sourceMappingURL=shadows-e287c7cc.js.map
